import SessionEvent from 'session/SessionEvent.js';
import Tone from 'tone';
import {TRACK_SEND_VOLUME_CHANGE} from 'session/constants.js';

class TrackSendVolumeChangeEvent extends SessionEvent {
    constructor(track, sendNumber, volume) {
        super();
        this.track = track;
        this.sendNumber = sendNumber;
        this.volume = volume;
    }

    executeEvent(sequencerEngine) {
        this.subSequence.tracks[this.track.trackNumber]
            .setSendVolume(this.sendNumber, this.volume, true);
    }

    getType() {
        return TRACK_SEND_VOLUME_CHANGE;
    }

    getJson() {
        return {
            ... super.getJson(),
            trackNumber: this.track.trackNumber,
            sendNumber: this.sendNumber,
            volume: this.volume
        };
    }

    fromJson(json, sequencerEngine) {
        super.fromJson(json);
        this.track  = sequencerEngine.tracks[json.trackNumber];
        this.sendNumber = json.sendNumber;
        this.volume = json.volume;
        return this;
    }
}

export default TrackSendVolumeChangeEvent;
